import { render, staticRenderFns } from "./gj-image.vue?vue&type=template&id=406aa399&scoped=true&"
import script from "./gj-image.vue?vue&type=script&lang=js&"
export * from "./gj-image.vue?vue&type=script&lang=js&"
import style0 from "./gj-image.vue?vue&type=style&index=0&id=406aa399&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406aa399",
  null
  
)

export default component.exports